import { Accordion, Text } from '@shared/components';
import { makeRootClassName } from '@shared/utils';
import { handlePlural } from 'clerk_common/stringification/handlePlural';
import { ReactNode } from 'react';

const SHIMMER_ROOT = makeRootClassName('ToolCallShimmer');

export function ToolCallGroup({
  callCount,
  children,
  liveTitle,
}: {
  callCount: number;
  children: ReactNode;
  liveTitle?: ReactNode;
}) {
  return (
    <Accordion
      triggerClassName="!w-auto !justify-start gap-1 rounded text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300 focus-visible:ring-offset-2"
      sections={[
        {
          trigger: liveTitle ? (
            <ToolCallShimmer>{liveTitle}</ToolCallShimmer>
          ) : (
            <Text type="body-sm">
              {handlePlural(callCount, 'tool call', 'tool calls')}
            </Text>
          ),
          children: (
            <div className="flex flex-col gap-1 pl-3 pt-1">{children}</div>
          ),
        },
      ]}
    />
  );
}

export function ToolCallShimmer({ children }: { children: ReactNode }) {
  return (
    <div className={SHIMMER_ROOT} data-testid="tool-call-shimmer">
      {children}
    </div>
  );
}
